import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { IStatesGetAllParams, IStatesResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IStatesResponse>>,
  IPathBaseParam,
  IPaginationParams & IStatesGetAllParams
>("geo.states");
const getApis = createGetApi<
  IApiResponse<IStatesResponse>,
  IPathByIdParam,
  object
>("geo.states");

export const states = {
  ...getAllApis,
  ...getApis,
};
